import { Checkbox } from 'antd';
import { useUnit } from 'effector-react';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import style from './D11Details.module.css';
import { $isBot, $isDarkTheme } from '../../../models/authModel/index.js';
import {
  $d11Parking,
  $d11Stops,
  $d11Switches,
  changeD11SwitchesEv,
} from '../../../models/rbpLiteModel/index.js';

function D11Details({ data }) {
  const isDark = useUnit($isDarkTheme);
  const d11Switches = useUnit($d11Switches);
  const changeD11Switches = useUnit(changeD11SwitchesEv);
  const d11Stops = useUnit($d11Stops);
  const d11Parking = useUnit($d11Parking);
  const isBot = useUnit($isBot);

  const onChange = (e, field) => {
    changeD11Switches({
      field,
      value: e.target.checked,
    });
  };

  return (
    <div style={{ marginTop: 35 }}>
      <div className={style.value_wrapper}>
        <div className={style.values}>
          <div style={{ color: isDark ? 'white' : '#717171', width: 150 }}>
            Пробки, бал
          </div>
          <div style={{ color: isDark ? 'white' : '#717171', width: 150 }}>
            {Math.round(data.reduce((a, b) => a + b, 0) / data.length)}/10
          </div>
        </div>
        {d11Switches.traffic_jams ? (
          <EyeOutlined
            className={style.eye_icon}
            onClick={() =>
              changeD11Switches({
                field: 'traffic_jams',
                value: false,
              })
            }
          />
        ) : (
          <EyeInvisibleOutlined
            id={isBot ? 'd11-eye' : null}
            className={style.eye_icon}
            onClick={() =>
              changeD11Switches({
                field: 'traffic_jams',
                value: true,
              })
            }
          />
        )}
        {/* <Checkbox */}
        {/*  checked={d11Switches.traffic_jams} */}
        {/*  onChange={(e) => onChange(e, 'traffic_jams')} */}
        {/* /> */}
      </div>
      <div className={style.value_wrapper}>
        <div className={style.values}>
          <div style={{ color: isDark ? 'white' : '#717171', width: 150 }}>
            Общественный транспорт
          </div>
          <div style={{ color: isDark ? 'white' : '#717171', width: 150 }}>
            {d11Stops.length} остановок
          </div>
        </div>
        {d11Switches.public_transport ? (
          <EyeOutlined
            className={style.eye_icon}
            onClick={() =>
              changeD11Switches({
                field: 'public_transport',
                value: false,
              })
            }
          />
        ) : (
          <EyeInvisibleOutlined
            className={style.eye_icon}
            onClick={() =>
              changeD11Switches({
                field: 'public_transport',
                value: true,
              })
            }
          />
        )}
        {/* <Checkbox */}
        {/*  checked={d11Switches.public_transport} */}
        {/*  onChange={(e) => onChange(e, 'public_transport')} */}
        {/* /> */}
      </div>
      <div className={style.value_wrapper}>
        <div className={style.values}>
          <div style={{ color: isDark ? 'white' : '#717171', width: 150 }}>
            Парковки
          </div>
          <div style={{ color: isDark ? 'white' : '#717171', width: 150 }}>
            {d11Parking.length} парковок
            <br />
            {d11Parking.reduce((a, b) => a + b.properties.parking_cnt, 0)} места
          </div>
        </div>
        {d11Switches.parking ? (
          <EyeOutlined
            className={style.eye_icon}
            onClick={() =>
              changeD11Switches({
                field: 'parking',
                value: false,
              })
            }
          />
        ) : (
          <EyeInvisibleOutlined
            className={style.eye_icon}
            onClick={() =>
              changeD11Switches({
                field: 'parking',
                value: true,
              })
            }
          />
        )}
        {/* <Checkbox */}
        {/*  checked={d11Switches.parking} */}
        {/*  onChange={(e) => onChange(e, 'parking')} */}
        {/* /> */}
      </div>
    </div>
  );
}

export default D11Details;
